module.exports = __webpack_public_path__ + "img/iOS.e5e16e3.svg";